import { render } from "./EncontroFormPage.vue?vue&type=template&id=1894c924&scoped=true"
import script from "./EncontroFormPage.vue?vue&type=script&lang=js"
export * from "./EncontroFormPage.vue?vue&type=script&lang=js"

import "./EncontroFormPage.vue?vue&type=style&index=0&id=1894c924&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1894c924"]])

export default __exports__